// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"9c995fd0","157":"4f0d3631","359":"29e1644d","496":"2283da55","576":"59b6c85f","797":"95055f1e"}[chunkId] + ".chunk.js";
};